import { useCallback } from "react";

import { Box, Stack, Collapse, IconButton } from "@mui/material";
import { ChevronDownIcon, ChevronUpIcon } from "components";
import { gray } from "configs/colors";
import { useToggle } from "hooks";
import { rem } from "utils";

interface CollapseProps {
  children: React.ReactNode;
  header: React.ReactNode;
  headerProps?: React.ComponentProps<typeof Stack>;
  defaultCollapsed?: boolean;
  callbackCollapse?: () => void;
}

const TLNCollapse: React.FC<CollapseProps> = ({
  header,
  children,
  defaultCollapsed,
  headerProps,
  callbackCollapse,
}) => {
  const [collapsed, toggleCollapsed] = useToggle(defaultCollapsed as boolean);
  const handleCollapse = useCallback(() => {
    toggleCollapsed();
    if (callbackCollapse) callbackCollapse();
  }, [callbackCollapse, toggleCollapsed]);

  return (
    <Box width="100%">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        padding={`${rem(16)} 0`}
        borderBottom={`1px solid ${gray[300]}`}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...headerProps}
      >
        <Box>{header}</Box>
        <IconButton size="medium" onClick={handleCollapse}>
          {collapsed ? (
            <ChevronUpIcon fontSize="medium" sx={{ color: gray[500] }} />
          ) : (
            <ChevronDownIcon fontSize="medium" sx={{ color: gray[500] }} />
          )}
        </IconButton>
      </Stack>
      <Collapse in={collapsed}>{children}</Collapse>
    </Box>
  );
};

export default TLNCollapse;
